/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

require('../../modules/es6.reflect.delete-property');
module.exports = require('../../modules/$.core').Reflect.deleteProperty;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/reflect/delete-property.js
 ** module id = 1323
 ** module chunks = 0
 **/